export default {
  meta: {
    title: '拓店管理-测评点位报表',
    url: '/fishtogether/evaluationreport', // 埋点用，记录所属模块
  },
};
